module.exports = __webpack_public_path__ + "img/options-dneye.86f06853.png";